import { render, staticRenderFns } from "./stadium-management.vue?vue&type=template&id=6132df66&scoped=true&"
import script from "./stadium-management.vue?vue&type=script&lang=js&"
export * from "./stadium-management.vue?vue&type=script&lang=js&"
import style0 from "./stadium-management.vue?vue&type=style&index=0&id=6132df66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132df66",
  null
  
)

export default component.exports